<template>
    <ResizableLayout
      left_content_class='folders-list'
      right_content_class='folders-dashboard'
    >
        <template #left-content>
           <FoldersListSection
              :folders_selection_collection='folders_selection_collection'
              :webmail_view='webmail_view'
           />
        </template>

        <template #right-content>
            <FoldersDashboardSection
              :folders_selection_collection='folders_selection_collection'
              :webmail_view='webmail_view'
            />
        </template>
    </ResizableLayout>
</template>

<script setup>
  import {reactive}              from 'vue';
  import {defineProps}           from 'vue';
  import FoldersListSection      from './Sections/FoldersListSection.vue';
  import FoldersDashboardSection from './Sections//FoldersDashboardSection.vue';
  import ResizableLayout         from '@/vue/Layouts/ResizableLayout.vue';
  import CollectionList          from '@/js/Shared/Collections/CollectionList';
  import MetadataController      from '@/js/Webmail/MetadataController';

  const props = defineProps({
    webmail_view : {
      required: true,
    }
  })

  const folders_selection_collection = reactive(new CollectionList('id'));
  MetadataController.setPageTitle('folders.title');
</script>